import { IDM_URL } from "@/constants";
import router from "@/router";
import store from "@/store";

//登录登出链接拼接处理
function paramsToString(apiParams: {
  baseUrl: string;
  apiUrl: string;
  params: { [key: string]: string };
}) {
  const { baseUrl, apiUrl, params } = apiParams;
  const paramsUrl = Object.entries(params)
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");
  const url = `${baseUrl}${apiUrl}?${paramsUrl}`;
  return url;
}

//认证
export function idmAuth() {
  const params = {
    baseUrl: IDM_URL,
    apiUrl: "/ssoLogin",
    params: { state: window.location.href, loginType: "idm" },
  };
  return new Promise((resolve, reject) => {
    window.location.href = paramsToString(params);
    resolve("success");
  });
}

export function gotoLogin(withCurrentPath = true) {
  store.commit("setToken", "");
  localStorage.setItem("idmToken", "");
  store.commit("setUserInfo", {});
  // 防止多次进入
  if (window.location.href.indexOf("/login") !== -1) {
    return;
  }
  let redirectUrl = "";
  if (withCurrentPath) {
    const href = window.location.href;
    const hashIndex = href.indexOf("#");
    redirectUrl = `${href.slice(hashIndex + 1)}`;
  }
  router.push(`/login${redirectUrl ? "?redirectUrl=" + redirectUrl : ""}`);
}

// 登出
export const logout = () => {
  if (store.state.base.token) {
    const host = window.location.origin;
    // 默认redirectUrl
    const url = `${host}/login?redirectUrl=/`;
    console.log("url :>> ", url);
    const params = {
      baseUrl: IDM_URL,
      apiUrl: "/logout",
      params: { state: url, loginType: "idm" },
      headers: { token: store.state.base.token },
    };
    console.log("params :>> ", params);
    // clearUserId();
    localStorage.setItem("idmToken", "");
    window.location.href = paramsToString(params);
  }
};
